import * as React from 'react';
import './StressBarometerCard.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../../stores';
import { IStressBarometer } from '../../../../interfaces/IStressBarometer';
import moment = require('moment');

export interface IProps {
  appStore?: AppStore;
  stressBarometer?: IStressBarometer;
  adminView?: boolean;
}

export interface IState {
}

@inject('appStore')
@observer
export default class StressBarometerCard extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      hasAccess: false
    }
  }

  render() {
    return (
      <div
        className='stressBarometerCard'
        style={{
          width: this.props.adminView ? 380 : "100%",
        }}
      >
        {this.props.adminView && this.props.stressBarometer?.areas[0]?.value == undefined &&
          <div
            className="stressBarometerEditButton"
            style={{
              backgroundImage: `url("https://img.icons8.com/external-anggara-basic-outline-anggara-putra/96/ffffff/external-edit-user-interface-anggara-basic-outline-anggara-putra-5.png")`,
            }}
            onClick={() => {
              this.props.appStore!.stressBarometerToEdit = this.props.stressBarometer;
            }}
          />
        }
        <h2>{this.props.stressBarometer?.title}</h2>
        <p>{moment(this.props.stressBarometer?.createdAt).format('LL')}</p>
        {!this.props.adminView && this.props.stressBarometer?.areas[0]?.value == undefined &&
          <div
            className="stressBarometerButton"
            onClick={() => {
              this.props.appStore!.stressBarometerToFillIn = this.props.stressBarometer;
            }}
            style={{
              backgroundColor: "gray"
            }}
          >
            {window.loc.strings.stressBarometerFillInButton.toUpperCase()}
          </div>
        }
        {this.props.stressBarometer?.areas[0]?.value !== undefined &&
          <div
            className="stressBarometerButton"
            onClick={() => {
              this.props.appStore!.stressBarometerToFillIn = this.props.stressBarometer;
            }}
            style={{
              backgroundColor: "#8047dd"
            }}
          >
            {window.loc.strings.stressBarometerSeeResultButton.toUpperCase()}
          </div>
        }
        {this.props.adminView && this.props.stressBarometer?.areas[0]?.value == undefined &&
          <div
            className="stressBarometerButton"
            style={{
              backgroundColor: "gray",
              opacity: 0.5,
              cursor: "wait"
            }}
          >
            {window.loc.strings.stressBarometerNotFilledIn.toUpperCase()}
          </div>
        }
        {this.props.adminView &&
          <div
            className="stressBarometerButton"
            style={{
              backgroundColor: "gray",
            }}
            onClick={() => {
              this.props.appStore!.stressBarometerToEdit = {
                allowUserToEditAreas: this.props.stressBarometer?.allowUserToEditAreas,
                adminId: this.props.appStore!.user?.id,
                title: this.props.stressBarometer?.title,
                areas: this.props.stressBarometer?.areas.map(area => ({ title: area.title })),
                userId: this.props.stressBarometer?.userId,
              }; 
            }}
          >
            {window.loc.strings.stressBarometerMakeACopy.toUpperCase()}
          </div>
        }
      </div>
    );
  }
}